// import React, { useState, useEffect } from 'react';
// import {
// 	Box,
// 	Paper,
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableContainer,
// 	TableHead,
// 	TableRow,
// 	Chip,
// 	IconButton,
// 	Tooltip,
// 	TextField,
// 	InputAdornment,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	Button,
// 	Typography,
// 	Select,
// 	MenuItem,
// 	FormControl,
// 	InputLabel,
// 	Checkbox,
// 	ListItemText,
// 	Popover,
// 	CircularProgress,
// 	TablePagination,
// 	Stack,
// 	Grid,
// 	Avatar,
// 	useMediaQuery,
// 	useTheme,
// } from '@mui/material';
// import {
// 	Search as SearchIcon,
// 	Refresh as RefreshIcon,
// 	Close as CloseIcon,
// 	Visibility as VisibilityIcon,
// 	ViewColumn as ViewColumnIcon,
// } from '@mui/icons-material';
// import { Container } from '@mui/system';
// import { getEnquires, updateEnquires } from '../../../services/api/Enquires';
// import Toast from '../Toast/page';

// interface Inquiry {
// 	_id: string;
// 	name: string;
// 	email: string;
// 	mobile: string;
// 	message: string;
// 	followupStatus: string;
// 	notification: boolean;
// 	createdAt: string;
// 	updatedAt: string;
// 	followUps?: FollowUp[];
// }

// interface FollowUp {
// 	id: string;
// 	date: string;
// 	notes: string;
// 	status: string;
// }

// const statusOptions = ['New', 'Pending', 'Converted', 'Rejected', 'Confirmed'];

// const columnOptions = [
// 	{ id: 'name', label: 'Customer' },
// 	{ id: 'email', label: 'Email' },
// 	{ id: 'mobile', label: 'Phone Number' },
// 	{ id: 'message', label: 'Message' },
// 	{ id: 'followupStatus', label: 'Status' },
// ];

// const InquiriesPage: React.FC = () => {
// 	const theme = useTheme();
// 	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// 	const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
// 	const [inquiries, setInquiries] = useState<Inquiry[]>([]);
// 	const [selectedInquiry, setSelectedInquiry] = useState<Inquiry | null>(null);
// 	const [openViewDialog, setOpenViewDialog] = useState(false);
// 	const [openEditDialog, setOpenEditDialog] = useState(false);
// 	const [followUpNotes, setFollowUpNotes] = useState<string>('');
// 	const [alertMessage, setAlertMessage] = useState<string | null>(null);
// 	const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'info' | 'warning'>(
// 		'success'
// 	);
// 	const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
// 		columnOptions.reduce((acc, col) => ({ ...acc, [col.id]: true }), {})
// 	);
// 	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
// 	const [loading, setLoading] = useState<boolean>(true);
// 	const [searchTerm, setSearchTerm] = useState<string>('');
// 	const [updatingStatus, setUpdatingStatus] = useState<string | null>(null);
// 	const [page, setPage] = useState(0);
// 	const [rowsPerPage, setRowsPerPage] = useState(10);

// 	useEffect(() => {
// 		fetchInquiries();
// 	}, []);

// 	const fetchInquiries = async () => {
// 		try {
// 			setLoading(true);
// 			const response = await getEnquires();
// 			setInquiries(response.data.inquiries);
// 			setAlertMessage('Enquires Data fetch Successfully');
// 			setAlertSeverity('success');
// 		} catch (error) {
// 			console.error('Error fetching inquiries:', error);
// 			setAlertMessage('Failed to fetch inquiries');
// 			setAlertSeverity('error');
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	const getStatusColor = (status: string) => {
// 		switch (status) {
// 			case 'New':
// 				return 'info';
// 			case 'Pending':
// 				return 'warning';
// 			case 'Converted':
// 			case 'Confirmed':
// 				return 'success';
// 			case 'Rejected':
// 				return 'error';
// 			case 'Contacted':
// 				return 'info';
// 			default:
// 				return 'default';
// 		}
// 	};

// 	const handleViewInquiry = async (inquiry: Inquiry) => {
// 		const fullInquiry = inquiries.find((inq) => inq._id === inquiry._id);
// 		if (fullInquiry) {
// 			setSelectedInquiry(fullInquiry);
// 			setOpenViewDialog(true);
// 		}
// 	};

// 	const handleCloseDialogs = () => {
// 		setOpenViewDialog(false);
// 		setOpenEditDialog(false);
// 		setSelectedInquiry(null);
// 	};

// 	const handleStatusChange = async (inquiryId: string, newStatus: string) => {
// 		setUpdatingStatus(inquiryId);
// 		try {
// 			const updatedInquiry = await updateEnquires({ followupStatus: newStatus }, inquiryId);
// 			console.log('Updated Inquiry:', updatedInquiry);

// 			if (updatedInquiry.success) {
// 				setInquiries(
// 					inquiries.map((inq) =>
// 						inq._id === updatedInquiry?.data?._id ? updatedInquiry?.data : inq
// 					)
// 				);
// 				setAlertMessage('Status updated successfully');
// 				setAlertSeverity('success');
// 			}
// 		} catch (error) {
// 			console.error('Error updating status:', error);
// 			setAlertMessage('Failed to update status');
// 			setAlertSeverity('error');
// 		} finally {
// 			setUpdatingStatus(null);
// 		}
// 	};

// 	const handleAddFollowUp = async () => {
// 		if (!selectedInquiry) return;
// 		const followUpData = {
// 			followupStatus: selectedInquiry.followupStatus,
// 			notes: followUpNotes,
// 		};

// 		try {
// 			const updatedInquiry = await updateEnquires(followUpData, selectedInquiry._id);

// 			if (updatedInquiry) {
// 				setInquiries(
// 					inquiries.map((inq) => (inq._id === updatedInquiry._id ? updatedInquiry : inq))
// 				);
// 				setFollowUpNotes('');
// 				setOpenEditDialog(false);
// 				setAlertMessage('Follow up added successfully');
// 				setAlertSeverity('success');
// 			}
// 		} catch (error) {
// 			console.error('Error adding follow up:', error);
// 			setAlertMessage('Failed to add follow up');
// 			setAlertSeverity('error');
// 		}
// 	};

// 	const handleColumnToggle = (columnId: string) => {
// 		setVisibleColumns({
// 			...visibleColumns,
// 			[columnId]: !visibleColumns[columnId],
// 		});
// 	};

// 	const handleColumnsMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
// 		setAnchorEl(event.currentTarget);
// 	};

// 	const handleColumnsMenuClose = () => {
// 		setAnchorEl(null);
// 	};

// 	const handleRefresh = () => {
// 		fetchInquiries();
// 		setPage(0);
// 	};

// 	const filteredInquiries = inquiries?.filter(
// 		(inquiry) =>
// 			inquiry.name.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
// 			inquiry.email.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
// 			inquiry.mobile.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
// 			inquiry.message.toLowerCase().startsWith(searchTerm.toLowerCase())
// 	);

// 	const handleChangePage = (event: unknown, newPage: number) => {
// 		setPage(newPage);
// 	};

// 	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
// 		setRowsPerPage(parseInt(event.target.value, 10));
// 		setPage(0);
// 	};

// 	const paginatedInquiries = filteredInquiries.slice(
// 		page * rowsPerPage,
// 		page * rowsPerPage + rowsPerPage
// 	);

// 	const formatDate = (dateString: string) => {
// 		const date = new Date(dateString);
// 		return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
// 	};

// 	// Responsive column visibility
// 	useEffect(() => {
// 		if (isMobile) {
// 			setVisibleColumns({
// 				name: true,
// 				email: false,
// 				mobile: true,
// 				message: false,
// 				followupStatus: true,
// 			});
// 		} else if (isTablet) {
// 			setVisibleColumns({
// 				name: true,
// 				email: true,
// 				mobile: true,
// 				message: false,
// 				followupStatus: true,
// 			});
// 		} else {
// 			setVisibleColumns(columnOptions.reduce((acc, col) => ({ ...acc, [col.id]: true }), {}));
// 		}
// 	}, [isMobile, isTablet]);

// 	return (
// 		<Container maxWidth={false} sx={{ width: '100%', pt: 3, pb: 4 }}>
// 			<Box
// 				sx={{
// 					display: 'flex',
// 					flexDirection: isMobile ? 'column' : 'row',
// 					justifyContent: 'space-between',
// 					mb: 3,
// 					gap: 2,
// 				}}
// 			>
// 				<TextField
// 					variant="outlined"
// 					size="small"
// 					placeholder="Search inquiries..."
// 					value={searchTerm}
// 					onChange={(e) => setSearchTerm(e.target.value)}
// 					InputProps={{
// 						startAdornment: (
// 							<InputAdornment position="start">
// 								<SearchIcon />
// 							</InputAdornment>
// 						),
// 					}}
// 					sx={{ width: isMobile ? '100%' : 300 }}
// 				/>
// 				<Box sx={{ display: 'flex', gap: 1 }}>
// 					<Tooltip title="Select columns">
// 						<IconButton onClick={handleColumnsMenuOpen}>
// 							<ViewColumnIcon />
// 						</IconButton>
// 					</Tooltip>
// 					<Tooltip title="Refresh">
// 						<IconButton onClick={handleRefresh}>
// 							<RefreshIcon />
// 						</IconButton>
// 					</Tooltip>
// 				</Box>
// 			</Box>

// 			<Popover
// 				open={Boolean(anchorEl)}
// 				anchorEl={anchorEl}
// 				onClose={handleColumnsMenuClose}
// 				anchorOrigin={{
// 					vertical: 'bottom',
// 					horizontal: 'right',
// 				}}
// 				transformOrigin={{
// 					vertical: 'top',
// 					horizontal: 'right',
// 				}}
// 			>
// 				<Box sx={{ p: 2 }}>
// 					<Typography variant="subtitle1" gutterBottom>
// 						Visible Columns
// 					</Typography>
// 					{columnOptions.map((column) => (
// 						<Box key={column.id} sx={{ display: 'flex', alignItems: 'center' }}>
// 							<Checkbox
// 								checked={visibleColumns[column.id]}
// 								onChange={() => handleColumnToggle(column.id)}
// 							/>
// 							<ListItemText primary={column.label} />
// 						</Box>
// 					))}
// 				</Box>
// 			</Popover>

// 			<Paper elevation={3} sx={{ p: 2, overflowX: 'auto' }}>
// 				{loading ? (
// 					<Box display="flex" justifyContent="center" p={4}>
// 						<CircularProgress />
// 					</Box>
// 				) : (
// 					<>
// 						<TableContainer>
// 							<Table size={isMobile ? 'small' : 'medium'}>
// 								<TableHead>
// 									<TableRow>
// 										{visibleColumns.name && <TableCell>Customer</TableCell>}
// 										{visibleColumns.email && <TableCell>Email</TableCell>}
// 										{visibleColumns.mobile && (
// 											<TableCell>Phone Number</TableCell>
// 										)}
// 										{visibleColumns.message && (
// 											<TableCell
// 												sx={{ display: isMobile ? 'none' : 'table-cell' }}
// 											>
// 												Message
// 											</TableCell>
// 										)}
// 										{visibleColumns.followupStatus && (
// 											<TableCell>Status</TableCell>
// 										)}
// 										<TableCell>Actions</TableCell>
// 									</TableRow>
// 								</TableHead>
// 								<TableBody>
// 									{paginatedInquiries.map((inquiry) => (
// 										<TableRow key={inquiry._id} hover>
// 											{visibleColumns.name && (
// 												<TableCell>{inquiry.name}</TableCell>
// 											)}
// 											{visibleColumns.email && (
// 												<TableCell sx={{ wordBreak: 'break-all' }}>
// 													{isMobile
// 														? ` ${inquiry.email.substring(0, 10)} + '...'`
// 														: inquiry.email}
// 												</TableCell>
// 											)}
// 											{visibleColumns.mobile && (
// 												<TableCell>{inquiry.mobile}</TableCell>
// 											)}
// 											{visibleColumns.message && (
// 												<TableCell
// 													sx={{
// 														maxWidth: 200,
// 														overflow: 'hidden',
// 														textOverflow: 'ellipsis',
// 														display: isMobile ? 'none' : 'table-cell',
// 													}}
// 												>
// 													{inquiry.message}
// 												</TableCell>
// 											)}
// 											{visibleColumns.followupStatus && (
// 												<TableCell>
// 													{updatingStatus === inquiry._id ? (
// 														<CircularProgress size={24} />
// 													) : (
// 														<FormControl size="small" fullWidth>
// 															<Select
// 																value={inquiry.followupStatus}
// 																onChange={(e) =>
// 																	handleStatusChange(
// 																		inquiry._id,
// 																		e.target.value as string
// 																	)
// 																}
// 																sx={{
// 																	border: 'none',
// 																	'& .MuiOutlinedInput-notchedOutline':
// 																	{
// 																		border: 'none',
// 																	},
// 																	'&:hover .MuiOutlinedInput-notchedOutline':
// 																	{
// 																		border: 'none',
// 																	},
// 																	'&.Mui-focused .MuiOutlinedInput-notchedOutline':
// 																	{
// 																		border: 'none',
// 																	},
// 																	'& .MuiSelect-select': {
// 																		py: 0.5,
// 																		px: 1,
// 																		display: 'flex',
// 																		alignItems: 'center',
// 																	},
// 																}}
// 															>
// 																{statusOptions.map((status) => (
// 																	<MenuItem
// 																		key={status}
// 																		value={status}
// 																	>
// 																		<Chip
// 																			label={status}
// 																			size="small"
// 																			color={getStatusColor(
// 																				status
// 																			)}
// 																			sx={{ width: '100%' }}
// 																		/>
// 																	</MenuItem>
// 																))}
// 															</Select>
// 														</FormControl>
// 													)}
// 												</TableCell>
// 											)}
// 											<TableCell>
// 												<Tooltip title="View">
// 													<IconButton
// 														size="small"
// 														sx={{ mr: 1 }}
// 														onClick={() => handleViewInquiry(inquiry)}
// 													>
// 														<VisibilityIcon fontSize="small" />
// 													</IconButton>
// 												</Tooltip>
// 											</TableCell>
// 										</TableRow>
// 									))}
// 								</TableBody>
// 							</Table>
// 						</TableContainer>
// 						<TablePagination
// 							rowsPerPageOptions={[5, 10, 25]}
// 							component="div"
// 							count={filteredInquiries.length}
// 							rowsPerPage={rowsPerPage}
// 							page={page}
// 							onPageChange={handleChangePage}
// 							onRowsPerPageChange={handleChangeRowsPerPage}
// 							sx={{
// 								'.MuiTablePagination-toolbar': {
// 									paddingLeft: 2,
// 								},
// 							}}
// 						/>
// 					</>
// 				)}
// 			</Paper>

// 			{/* View Inquiry Dialog */}
// 			<Dialog
// 				open={openViewDialog}
// 				onClose={handleCloseDialogs}
// 				maxWidth="md"
// 				fullWidth
// 				fullScreen={isMobile}
// 				PaperProps={{
// 					sx: {
// 						borderRadius: isMobile ? 0 : 2,
// 						boxShadow: 24,
// 					},
// 				}}
// 			>
// 				<DialogTitle
// 					sx={{
// 						color: 'black',
// 						padding: 2,
// 						display: 'flex',
// 						justifyContent: 'space-between',
// 						alignItems: 'center',
// 					}}
// 				>
// 					<Typography variant="h6" fontWeight="bold">
// 						Inquiry Details
// 					</Typography>
// 					<IconButton onClick={handleCloseDialogs}>
// 						<CloseIcon />
// 					</IconButton>
// 				</DialogTitle>

// 				<DialogContent dividers sx={{ padding: isMobile ? 1 : 3 }}>
// 					{selectedInquiry && (
// 						<Box>
// 							{/* Header Section */}
// 							<Box
// 								sx={{
// 									display: 'flex',
// 									alignItems: 'center',
// 									mb: 3,
// 									paddingBottom: 2,
// 									borderBottom: '1px solid',
// 									borderColor: 'divider',
// 								}}
// 							>
// 								<Avatar
// 									sx={{
// 										bgcolor: 'primary.main',
// 										width: 56,
// 										height: 56,
// 										mr: 2,
// 										fontSize: '1.5rem',
// 									}}
// 								>
// 									{selectedInquiry.name.charAt(0)}
// 								</Avatar>
// 								<Box>
// 									<Typography variant={isMobile ? 'h6' : 'h5'} fontWeight="bold">
// 										{selectedInquiry.name}
// 									</Typography>
// 									<Typography variant="body2" color="text.secondary">
// 										Inquiry ID: {selectedInquiry._id.substring(0, 8)}...
// 									</Typography>
// 								</Box>
// 							</Box>

// 							{/* Contact Information */}
// 							<Grid container spacing={3} sx={{ mb: 3 }}>
// 								<Grid item xs={12} md={6}>
// 									<Paper
// 										elevation={0}
// 										sx={{
// 											p: 2,
// 											borderLeft: '4px solid',
// 											borderColor: 'info.main',
// 											backgroundColor: 'grey.50',
// 										}}
// 									>
// 										<Typography
// 											variant="subtitle1"
// 											fontWeight="bold"
// 											gutterBottom
// 											color="text.secondary"
// 										>
// 											Contact Information
// 										</Typography>

// 										<Stack spacing={1.5}>
// 											<Box>
// 												<Typography
// 													variant="caption"
// 													color="text.secondary"
// 												>
// 													Email
// 												</Typography>
// 												<Typography sx={{ wordBreak: 'break-all' }}>
// 													{selectedInquiry.email}
// 												</Typography>
// 											</Box>

// 											<Box>
// 												<Typography
// 													variant="caption"
// 													color="text.secondary"
// 												>
// 													Phone
// 												</Typography>
// 												<Typography>{selectedInquiry.mobile}</Typography>
// 											</Box>
// 										</Stack>
// 									</Paper>
// 								</Grid>

// 								<Grid item xs={12} md={6}>
// 									<Paper
// 										elevation={0}
// 										sx={{
// 											p: 2,
// 											borderLeft: '4px solid',
// 											borderColor: 'success.main',
// 											backgroundColor: 'grey.50',
// 										}}
// 									>
// 										<Typography
// 											variant="subtitle1"
// 											fontWeight="bold"
// 											gutterBottom
// 											color="text.secondary"
// 										>
// 											Status Information
// 										</Typography>

// 										<Stack spacing={1.5}>
// 											<Box>
// 												<Typography
// 													variant="caption"
// 													color="text.secondary"
// 												>
// 													Follow-up Status
// 												</Typography>
// 												<Box sx={{ display: 'flex', alignItems: 'center' }}>
// 													<Chip
// 														label={selectedInquiry.followupStatus}
// 														color={getStatusColor(
// 															selectedInquiry.followupStatus
// 														)}
// 														size="medium"
// 														sx={{ fontWeight: 'bold' }}
// 													/>
// 												</Box>
// 											</Box>

// 											<Box>
// 												<Typography
// 													variant="caption"
// 													color="text.secondary"
// 												>
// 													Notification
// 												</Typography>
// 												<Typography>
// 													{selectedInquiry.notification
// 														? 'Enabled'
// 														: 'Disabled'}
// 												</Typography>
// 											</Box>
// 										</Stack>
// 									</Paper>
// 								</Grid>
// 							</Grid>

// 							{/* Message Section */}
// 							<Box sx={{ mb: 3 }}>
// 								<Typography
// 									variant="subtitle1"
// 									fontWeight="bold"
// 									gutterBottom
// 									color="text.secondary"
// 								>
// 									Message
// 								</Typography>
// 								<Paper variant="outlined" sx={{ p: 2 }}>
// 									<Typography sx={{ whiteSpace: 'pre-line' }}>
// 										{selectedInquiry.message || 'No message provided'}
// 									</Typography>
// 								</Paper>
// 							</Box>

// 							{/* Follow-ups Section */}
// 							{selectedInquiry.followUps && selectedInquiry.followUps.length > 0 && (
// 								<Box>
// 									<Typography
// 										variant="subtitle1"
// 										fontWeight="bold"
// 										gutterBottom
// 										color="text.secondary"
// 									>
// 										Follow-up History
// 									</Typography>
// 									<TableContainer component={Paper} variant="outlined">
// 										<Table size="small">
// 											<TableHead sx={{ backgroundColor: 'grey.100' }}>
// 												<TableRow>
// 													<TableCell sx={{ fontWeight: 'bold' }}>
// 														Date
// 													</TableCell>
// 													<TableCell sx={{ fontWeight: 'bold' }}>
// 														Status
// 													</TableCell>
// 													<TableCell sx={{ fontWeight: 'bold' }}>
// 														Notes
// 													</TableCell>
// 												</TableRow>
// 											</TableHead>
// 											<TableBody>
// 												{selectedInquiry.followUps.map(
// 													(followUp, index) => (
// 														<TableRow
// 															key={index}
// 															sx={{
// 																'&:nth-of-type(odd)': {
// 																	backgroundColor: 'action.hover',
// 																},
// 															}}
// 														>
// 															<TableCell>
// 																{new Date(
// 																	followUp.date
// 																).toLocaleDateString('en-US', {
// 																	year: 'numeric',
// 																	month: 'short',
// 																	day: 'numeric',
// 																})}
// 															</TableCell>
// 															<TableCell>
// 																<Chip
// 																	label={followUp.status}
// 																	color={getStatusColor(
// 																		followUp.status
// 																	)}
// 																	size="small"
// 																/>
// 															</TableCell>
// 															<TableCell
// 																sx={{ whiteSpace: 'pre-line' }}
// 															>
// 																{followUp.notes}
// 															</TableCell>
// 														</TableRow>
// 													)
// 												)}
// 											</TableBody>
// 										</Table>
// 									</TableContainer>
// 								</Box>
// 							)}
// 						</Box>
// 					)}
// 				</DialogContent>

// 				<DialogActions sx={{ padding: 2 }}>
// 					<Button
// 						onClick={handleCloseDialogs}
// 						variant="outlined"
// 						sx={{
// 							px: 3,
// 							'&:hover': {
// 								backgroundColor: 'grey.100',
// 							},
// 						}}
// 						fullWidth={isMobile}
// 					>
// 						Close
// 					</Button>
// 				</DialogActions>
// 			</Dialog>

// 			{/* Edit Inquiry Dialog */}
// 			<Dialog
// 				open={openEditDialog}
// 				onClose={handleCloseDialogs}
// 				maxWidth="md"
// 				fullWidth
// 				fullScreen={isMobile}
// 			>
// 				<DialogTitle>
// 					<Box display="flex" justifyContent="space-between" alignItems="center">
// 						Update Inquiry
// 						<IconButton onClick={handleCloseDialogs}>
// 							<CloseIcon />
// 						</IconButton>
// 					</Box>
// 				</DialogTitle>
// 				<DialogContent dividers>
// 					{selectedInquiry && (
// 						<Box>
// 							<Box
// 								display="flex"
// 								mb={3}
// 								flexDirection={isMobile ? 'column' : 'row'}
// 								flexWrap="wrap"
// 							>
// 								<Box
// 									width={isMobile ? '100%' : '50%'}
// 									minWidth={isMobile ? undefined : 300}
// 									pr={isMobile ? 0 : 2}
// 								>
// 									<Typography variant="h6" gutterBottom>
// 										Inquiry Details
// 									</Typography>
// 									<TextField
// 										label="Name"
// 										value={selectedInquiry.name}
// 										fullWidth
// 										margin="normal"
// 										variant="outlined"
// 										InputProps={{
// 											readOnly: true,
// 										}}
// 									/>
// 									<TextField
// 										label="Email"
// 										value={selectedInquiry.email}
// 										fullWidth
// 										margin="normal"
// 										variant="outlined"
// 										InputProps={{
// 											readOnly: true,
// 										}}
// 									/>
// 									<TextField
// 										label="Phone Number"
// 										value={selectedInquiry.mobile}
// 										fullWidth
// 										margin="normal"
// 										variant="outlined"
// 										InputProps={{
// 											readOnly: true,
// 										}}
// 									/>
// 								</Box>
// 								<Box
// 									width={isMobile ? '100%' : '20%'}
// 									minWidth={isMobile ? undefined : 100}
// 									pl={isMobile ? 0 : 2}
// 								>
// 									<Typography variant="h6" gutterBottom>
// 										Status
// 									</Typography>
// 									<FormControl fullWidth margin="normal">
// 										<InputLabel>Follow Up Status</InputLabel>
// 										<Select
// 											value={selectedInquiry.followupStatus}
// 											label="Follow Up Status"
// 											onChange={(e) =>
// 												handleStatusChange(
// 													selectedInquiry._id,
// 													e.target.value as string
// 												)
// 											}
// 										>
// 											{statusOptions.map((status) => (
// 												<MenuItem key={status} value={status}>
// 													<Chip
// 														label={status}
// 														size="small"
// 														color={getStatusColor(status)}
// 														sx={{ width: '100%' }}
// 													/>
// 												</MenuItem>
// 											))}
// 										</Select>
// 									</FormControl>
// 									<TextField
// 										label="Created At"
// 										value={formatDate(selectedInquiry.createdAt)}
// 										fullWidth
// 										margin="normal"
// 										variant="outlined"
// 										InputProps={{
// 											readOnly: true,
// 										}}
// 									/>
// 								</Box>
// 							</Box>

// 							<Box mt={2}>
// 								<Typography variant="subtitle1" gutterBottom>
// 									<strong>Original Message:</strong>
// 								</Typography>
// 								<Typography
// 									paragraph
// 									sx={{ p: 1, backgroundColor: '#f5f5f5', borderRadius: 1 }}
// 								>
// 									{selectedInquiry.message}
// 								</Typography>
// 							</Box>

// 							<Box mt={3}>
// 								<Typography variant="h6" gutterBottom>
// 									Add Follow Up Notes
// 								</Typography>
// 								<TextField
// 									label="Notes"
// 									value={followUpNotes}
// 									onChange={(e) => setFollowUpNotes(e.target.value)}
// 									fullWidth
// 									margin="normal"
// 									variant="outlined"
// 									multiline
// 									rows={4}
// 								/>
// 							</Box>

// 							{selectedInquiry.followUps && selectedInquiry.followUps.length > 0 && (
// 								<Box mt={3}>
// 									<Typography variant="h6" gutterBottom>
// 										Previous Follow Ups
// 									</Typography>
// 									<TableContainer component={Paper} variant="outlined">
// 										<Table size="small">
// 											<TableHead>
// 												<TableRow>
// 													<TableCell>Date</TableCell>
// 													<TableCell>Status</TableCell>
// 													<TableCell>Notes</TableCell>
// 												</TableRow>
// 											</TableHead>
// 											<TableBody>
// 												{selectedInquiry.followUps.map(
// 													(followUp, index) => (
// 														<TableRow key={index}>
// 															<TableCell>{followUp.date}</TableCell>
// 															<TableCell>
// 																<Chip
// 																	label={followUp.status}
// 																	color={getStatusColor(
// 																		followUp.status
// 																	)}
// 																	size="small"
// 																/>
// 															</TableCell>
// 															<TableCell>{followUp.notes}</TableCell>
// 														</TableRow>
// 													)
// 												)}
// 											</TableBody>
// 										</Table>
// 									</TableContainer>
// 								</Box>
// 							)}
// 						</Box>
// 					)}
// 				</DialogContent>
// 				<DialogActions>
// 					<Button
// 						onClick={handleCloseDialogs}
// 						sx={{
// 							'&:hover': {
// 								backgroundColor: 'primary.main',
// 								color: 'white',
// 							},
// 						}}
// 						fullWidth={isMobile}
// 					>
// 						Cancel
// 					</Button>
// 					<Button
// 						variant="contained"
// 						color="primary"
// 						onClick={handleAddFollowUp}
// 						fullWidth={isMobile}
// 						sx={{ mt: isMobile ? 1 : 0 }}
// 					>
// 						Save Changes
// 					</Button>
// 				</DialogActions>
// 			</Dialog>

// 			<Toast
// 				setAlertMessage={setAlertMessage}
// 				alertMessage={alertMessage}
// 				alertSeverity={alertSeverity}
// 			/>
// 		</Container>
// 	);
// };

// export default InquiriesPage;
import React, { useState, useEffect } from 'react';
import {
	Box,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Chip,
	IconButton,
	Tooltip,
	TextField,
	InputAdornment,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	Typography,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Checkbox,
	ListItemText,
	Popover,
	CircularProgress,
	TablePagination,
	Stack,
	Grid,
	Avatar,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import {
	Search as SearchIcon,
	Refresh as RefreshIcon,
	Close as CloseIcon,
	Visibility as VisibilityIcon,
	ViewColumn as ViewColumnIcon,
	Add as AddIcon,
} from '@mui/icons-material';
import { Container } from '@mui/system';
import { getEnquires, updateEnquires, ContactusApi } from '../../../services/api/Enquires';
// import {  } from '../../../services/api/Enquires';
import Toast from '../Toast/page';

interface Inquiry {
	_id: string;
	name: string;
	email: string;
	mobile: string;
	message: string;
	followupStatus: string;
	notification: boolean;
	createdAt: string;
	updatedAt: string;
	followUps?: FollowUp[];
	status?: string;
}

interface FollowUp {
	id: string;
	date: string;
	notes: string;
	status: string;
}

interface ContactFormData {
	name: string;
	email: string;
	contactNo: string;
	location: string;
	description: string;
}

const statusOptions = ['New', 'Menu Sent', 'Converted', 'Rejected', 'Quotation Sent'];

const columnOptions = [
	{ id: 'name', label: 'Customer' },
	{ id: 'email', label: 'Email' },
	{ id: 'mobile', label: 'Phone Number' },
	{ id: 'message', label: 'Message' },
	{ id: 'status', label: 'Status' },
];

const InquiriesPage: React.FC = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
	const [inquiries, setInquiries] = useState<Inquiry[]>([]);
	const [selectedInquiry, setSelectedInquiry] = useState<Inquiry | null>(null);
	const [openViewDialog, setOpenViewDialog] = useState(false);
	const [openEditDialog, setOpenEditDialog] = useState(false);
	const [openContactForm, setOpenContactForm] = useState(false);
	const [followUpNotes, setFollowUpNotes] = useState<string>('');
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'info' | 'warning'>(
		'success'
	);
	const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
		columnOptions.reduce((acc, col) => ({ ...acc, [col.id]: true }), {})
	);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [searchTerm, setSearchTerm] = useState<string>('');
	const [updatingStatus, setUpdatingStatus] = useState<string | null>(null);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [contactFormData, setContactFormData] = useState<ContactFormData>({
		name: '',
		email: '',
		contactNo: '',
		location: '',
		description: '',
	});
	const [contactFormErrors, setContactFormErrors] = useState<Record<string, string>>({});
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		fetchInquiries();
	}, []);

	const fetchInquiries = async () => {
		try {
			setLoading(true);
			const response = await getEnquires();
			setInquiries(response.data.inquiries.reverse());
			// setAlertMessage('Enquires Data fetch Successfully');
			// setAlertSeverity('success');
		} catch (error) {
			console.error('Error fetching inquiries:', error);
			setAlertMessage('Failed to fetch inquiries');
			setAlertSeverity('error');
		} finally {
			setLoading(false);
		}
	};

	const getStatusColor = (status: string) => {
		switch (status) {
			case 'New':
				return 'info';
			case 'Menu Sent':
				return 'warning';
			case 'Converted':
			case 'Quotation Sent':
				return 'success';
			case 'Rejected':
				return 'error';
			case 'Contacted':
				return 'info';
			default:
				return 'default';
		}
	};

	const handleViewInquiry = async (inquiry: Inquiry) => {
		const fullInquiry = inquiries.find((inq) => inq._id === inquiry._id);
		if (fullInquiry) {
			setSelectedInquiry(fullInquiry);
			setOpenViewDialog(true);
		}
	};

	const handleCloseDialogs = () => {
		setOpenViewDialog(false);
		setOpenEditDialog(false);
		setSelectedInquiry(null);
	};

	const handleStatusChange = async (inquiryId: string, newStatus: string) => {
		// switch (newStatus) {
		// 	case 'Quotation Sent':
		// 		return 'QUOTATIONSENT';
		// 	case 'Rejected':
		// 		return 'REJECTED';
		// 	case 'Converted':
		// 		return 'CONVERTED';
		// 	case 'Menu Sent':
		// 		return 'MENUSENT';
		// 		case 'New'
		// }

		setUpdatingStatus(inquiryId);
		try {
			const updatedInquiry = await updateEnquires({ status: newStatus }, inquiryId);
			console.log('Updated Inquiry:', updatedInquiry);

			if (updatedInquiry.success) {
				setInquiries(
					inquiries.map((inq) =>
						inq._id === updatedInquiry?.data?._id ? updatedInquiry?.data : inq
					)
				);
				setAlertMessage('Status updated successfully');
				setAlertSeverity('success');
			}
		} catch (error) {
			console.error('Error updating status:', error);
			setAlertMessage('Failed to update status');
			setAlertSeverity('error');
		} finally {
			setUpdatingStatus(null);
		}
	};

	const handleAddFollowUp = async () => {
		if (!selectedInquiry) return;
		const followUpData = {
			followupStatus: selectedInquiry.followupStatus,
			notes: followUpNotes,
		};

		try {
			const updatedInquiry = await updateEnquires(followUpData, selectedInquiry._id);

			if (updatedInquiry) {
				setInquiries(
					inquiries.map((inq) => (inq._id === updatedInquiry._id ? updatedInquiry : inq))
				);
				setFollowUpNotes('');
				setOpenEditDialog(false);
				setAlertMessage('Follow up added successfully');
				setAlertSeverity('success');
			}
		} catch (error) {
			console.error('Error adding follow up:', error);
			setAlertMessage('Failed to add follow up');
			setAlertSeverity('error');
		}
	};

	const handleColumnToggle = (columnId: string) => {
		setVisibleColumns({
			...visibleColumns,
			[columnId]: !visibleColumns[columnId],
		});
	};

	const handleColumnsMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleColumnsMenuClose = () => {
		setAnchorEl(null);
	};

	const handleRefresh = () => {
		fetchInquiries();
		setPage(0);
	};

	const handleContactFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setContactFormData({
			...contactFormData,
			[name]: value,
		});

		if (contactFormErrors[name]) {
			setContactFormErrors({
				...contactFormErrors,
				[name]: '',
			});
		}
	};

	const validateContactForm = (): boolean => {
		const newErrors: Record<string, string> = {};

		if (!contactFormData.name.trim()) {
			newErrors.name = 'Name is required';
		}

		if (!contactFormData.email.trim()) {
			newErrors.email = 'Email is required';
		} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactFormData.email)) {
			newErrors.email = 'Please enter a valid email';
		}

		if (!contactFormData.contactNo.trim()) {
			newErrors.contactNo = 'Contact number is required';
		} else if (!/^\d{10,15}$/.test(contactFormData.contactNo)) {
			newErrors.contactNo = 'Please enter a valid contact number';
		}

		if (!contactFormData.description.trim()) {
			newErrors.description = 'Description is required';
		}

		setContactFormErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleContactFormSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!validateContactForm()) return;

		setIsSubmitting(true);
		try {
			const data = {
				name: contactFormData.name,
				email: contactFormData.email,
				mobile: contactFormData.contactNo,
				message: contactFormData.description,
				source: 'Offline',
				location: contactFormData.location,
			};

			const response = await ContactusApi(data);
			if (response.success) {
				setAlertMessage('Inquiry submitted successfully!');
				setAlertSeverity('success');
				setContactFormData({
					name: '',
					email: '',
					contactNo: '',
					location: '',
					description: '',
				});
				setOpenContactForm(false);
				fetchInquiries();
			}
		} catch (error) {
			console.error('Error submitting contact form:', error);
			setAlertMessage('Failed to submit inquiry');
			setAlertSeverity('error');
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleOpenContactForm = () => {
		setOpenContactForm(true);
	};

	const handleCloseContactForm = () => {
		setOpenContactForm(false);
		setContactFormErrors({});
	};

	const filteredInquiries = inquiries?.filter(
		(inquiry) =>
			inquiry.name.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
			inquiry.email.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
			inquiry.mobile.toLowerCase().startsWith(searchTerm.toLowerCase()) ||
			inquiry.message.toLowerCase().startsWith(searchTerm.toLowerCase())
	);

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const paginatedInquiries = filteredInquiries.slice(
		page * rowsPerPage,
		page * rowsPerPage + rowsPerPage
	);

	const formatDate = (dateString: string) => {
		const date = new Date(dateString);
		return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
	};

	useEffect(() => {
		if (isMobile) {
			setVisibleColumns({
				name: true,
				email: false,
				mobile: true,
				message: false,
				status: true,
			});
		} else if (isTablet) {
			setVisibleColumns({
				name: true,
				email: true,
				mobile: true,
				message: false,
				status: true,
			});
		} else {
			setVisibleColumns(columnOptions.reduce((acc, col) => ({ ...acc, [col.id]: true }), {}));
		}
	}, [isMobile, isTablet]);

	return (
		<Container maxWidth={false} sx={{ width: '100%', pt: 3, pb: 4 }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: isMobile ? 'column' : 'row',
					justifyContent: 'space-between',
					mb: 3,
					gap: 2,
				}}
			>
				<TextField
					variant="outlined"
					size="small"
					placeholder="Search inquiries..."
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon />
							</InputAdornment>
						),
					}}
					sx={{ width: isMobile ? '100%' : 300 }}
				/>
				<Box sx={{ display: 'flex', gap: 1 }}>
					<Button
						variant="contained"
						color="primary"
						startIcon={<AddIcon />}
						onClick={handleOpenContactForm}
						sx={{ mr: 1 }}
					>
						Add Inquiry
					</Button>
					<Tooltip title="Select columns">
						<IconButton onClick={handleColumnsMenuOpen}>
							<ViewColumnIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Refresh">
						<IconButton onClick={handleRefresh}>
							<RefreshIcon />
						</IconButton>
					</Tooltip>
				</Box>
			</Box>

			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleColumnsMenuClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<Box sx={{ p: 2 }}>
					<Typography variant="subtitle1" gutterBottom>
						Visible Columns
					</Typography>
					{columnOptions.map((column) => (
						<Box key={column.id} sx={{ display: 'flex', alignItems: 'center' }}>
							<Checkbox
								checked={visibleColumns[column.id]}
								onChange={() => handleColumnToggle(column.id)}
							/>
							<ListItemText primary={column.label} />
						</Box>
					))}
				</Box>
			</Popover>

			<Paper elevation={3} sx={{ p: 2, overflowX: 'auto' }}>
				{loading ? (
					<Box display="flex" justifyContent="center" p={4}>
						<CircularProgress />
					</Box>
				) : (
					<>
						<TableContainer>
							<Table size={isMobile ? 'small' : 'medium'}>
								<TableHead>
									<TableRow>
										{visibleColumns.name && <TableCell>Customer</TableCell>}
										{visibleColumns.email && <TableCell>Email</TableCell>}
										{visibleColumns.mobile && (
											<TableCell>Phone Number</TableCell>
										)}
										{visibleColumns.message && (
											<TableCell
												sx={{ display: isMobile ? 'none' : 'table-cell' }}
											>
												Message
											</TableCell>
										)}
										{visibleColumns.status && <TableCell>Status</TableCell>}
										<TableCell>Actions</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{paginatedInquiries.map((inquiry) => (
										<TableRow key={inquiry._id} hover>
											{visibleColumns.name && (
												<TableCell
													onClick={() => handleViewInquiry(inquiry)}
												>
													{inquiry.name}
												</TableCell>
											)}
											{visibleColumns.email && (
												<TableCell sx={{ wordBreak: 'break-all' }}>
													{isMobile
														? `${inquiry.email.substring(0, 10)}...`
														: inquiry.email}
												</TableCell>
											)}
											{visibleColumns.mobile && (
												<TableCell>{inquiry.mobile}</TableCell>
											)}
											{visibleColumns.message && (
												<TableCell
													sx={{
														maxWidth: 200,
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														display: isMobile ? 'none' : 'table-cell',
													}}
												>
													{inquiry.message}
												</TableCell>
											)}
											{visibleColumns.status && (
												<TableCell>
													{updatingStatus === inquiry._id ? (
														<CircularProgress size={24} />
													) : (
														<FormControl size="small">
															<Select
																value={inquiry.status}
																onChange={(e) =>
																	handleStatusChange(
																		inquiry._id,
																		e.target.value as string
																	)
																}
																sx={{
																	border: 'none',
																	'& .MuiOutlinedInput-notchedOutline':
																		{
																			border: 'none',
																		},
																	'&:hover .MuiOutlinedInput-notchedOutline':
																		{
																			border: 'none',
																		},
																	'&.Mui-focused .MuiOutlinedInput-notchedOutline':
																		{
																			border: 'none',
																		},
																	'& .MuiSelect-select': {
																		py: 0.5,
																		px: 1,
																		display: 'flex',
																		alignItems: 'center',
																	},
																}}
															>
																{statusOptions.map((status) => (
																	<MenuItem
																		key={status}
																		value={status}
																	>
																		<Chip
																			label={status}
																			size="small"
																			color={getStatusColor(
																				status
																			)}
																			sx={{ width: '100%' }}
																		/>
																	</MenuItem>
																))}
															</Select>
														</FormControl>
													)}
												</TableCell>
											)}
											<TableCell>
												<Tooltip title="View">
													<IconButton
														size="small"
														sx={{ mr: 1 }}
														onClick={() => handleViewInquiry(inquiry)}
													>
														<VisibilityIcon fontSize="small" />
													</IconButton>
												</Tooltip>
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={filteredInquiries.length}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							sx={{
								'.MuiTablePagination-toolbar': {
									paddingLeft: 2,
								},
							}}
						/>
					</>
				)}
			</Paper>

			{/* View Inquiry Dialog */}
			<Dialog
				open={openViewDialog}
				onClose={handleCloseDialogs}
				maxWidth="md"
				fullWidth
				fullScreen={isMobile}
				PaperProps={{
					sx: {
						borderRadius: isMobile ? 0 : 2,
						boxShadow: 24,
					},
				}}
			>
				<DialogTitle
					sx={{
						color: 'black',
						padding: 2,
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Typography variant="h6" fontWeight="bold">
						Inquiry Details
					</Typography>
					<IconButton onClick={handleCloseDialogs}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent dividers sx={{ padding: isMobile ? 1 : 3 }}>
					{selectedInquiry && (
						<Box>
							{/* Header Section */}
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									mb: 3,
									paddingBottom: 2,
									borderBottom: '1px solid',
									borderColor: 'divider',
								}}
							>
								<Avatar
									sx={{
										bgcolor: 'primary.main',
										width: 56,
										height: 56,
										mr: 2,
										fontSize: '1.5rem',
									}}
								>
									{selectedInquiry.name.charAt(0)}
								</Avatar>
								<Box>
									<Typography variant={isMobile ? 'h6' : 'h5'} fontWeight="bold">
										{selectedInquiry.name}
									</Typography>
									<Typography variant="body2" color="text.secondary">
										Inquiry ID: {selectedInquiry._id.substring(0, 8)}...
									</Typography>
								</Box>
							</Box>

							{/* Contact Information */}
							<Grid container spacing={3} sx={{ mb: 3 }}>
								<Grid item xs={12} md={6}>
									<Paper
										elevation={0}
										sx={{
											p: 2,
											borderLeft: '4px solid',
											borderColor: 'info.main',
											backgroundColor: 'grey.50',
										}}
									>
										<Typography
											variant="subtitle1"
											fontWeight="bold"
											gutterBottom
											color="text.secondary"
										>
											Contact Information
										</Typography>

										<Stack spacing={1.5}>
											<Box>
												<Typography
													variant="caption"
													color="text.secondary"
												>
													Email
												</Typography>
												<Typography sx={{ wordBreak: 'break-all' }}>
													{selectedInquiry.email}
												</Typography>
											</Box>

											<Box>
												<Typography
													variant="caption"
													color="text.secondary"
												>
													Phone
												</Typography>
												<Typography>{selectedInquiry.mobile}</Typography>
											</Box>
										</Stack>
									</Paper>
								</Grid>

								<Grid item xs={12} md={6}>
									<Paper
										elevation={0}
										sx={{
											p: 2,
											borderLeft: '4px solid',
											borderColor: 'success.main',
											backgroundColor: 'grey.50',
										}}
									>
										<Typography
											variant="subtitle1"
											fontWeight="bold"
											gutterBottom
											color="text.secondary"
										>
											Status Information
										</Typography>

										<Stack spacing={1.5}>
											<Box>
												<Typography
													variant="caption"
													color="text.secondary"
												>
													Follow-up Status
												</Typography>
												<Box sx={{ display: 'flex', alignItems: 'center' }}>
													<Chip
														label={selectedInquiry.followupStatus}
														color={getStatusColor(
															selectedInquiry.followupStatus
														)}
														size="medium"
														sx={{ fontWeight: 'bold' }}
													/>
												</Box>
											</Box>

											<Box>
												<Typography
													variant="caption"
													color="text.secondary"
												>
													Notification
												</Typography>
												<Typography>
													{selectedInquiry.notification
														? 'Enabled'
														: 'Disabled'}
												</Typography>
											</Box>
										</Stack>
									</Paper>
								</Grid>
							</Grid>

							{/* Message Section */}
							<Box sx={{ mb: 3 }}>
								<Typography
									variant="subtitle1"
									fontWeight="bold"
									gutterBottom
									color="text.secondary"
								>
									Message
								</Typography>
								<Paper variant="outlined" sx={{ p: 2 }}>
									<Typography sx={{ whiteSpace: 'pre-line' }}>
										{selectedInquiry.message || 'No message provided'}
									</Typography>
								</Paper>
							</Box>

							{/* Follow-ups Section */}
							{selectedInquiry.followUps && selectedInquiry.followUps.length > 0 && (
								<Box>
									<Typography
										variant="subtitle1"
										fontWeight="bold"
										gutterBottom
										color="text.secondary"
									>
										Follow-up History
									</Typography>
									<TableContainer component={Paper} variant="outlined">
										<Table size="small">
											<TableHead sx={{ backgroundColor: 'grey.100' }}>
												<TableRow>
													<TableCell sx={{ fontWeight: 'bold' }}>
														Date
													</TableCell>
													<TableCell sx={{ fontWeight: 'bold' }}>
														Status
													</TableCell>
													<TableCell sx={{ fontWeight: 'bold' }}>
														Notes
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{selectedInquiry.followUps.map(
													(followUp, index) => (
														<TableRow
															key={index}
															sx={{
																'&:nth-of-type(odd)': {
																	backgroundColor: 'action.hover',
																},
															}}
														>
															<TableCell>
																{new Date(
																	followUp.date
																).toLocaleDateString('en-US', {
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric',
																})}
															</TableCell>
															<TableCell>
																<Chip
																	label={followUp.status}
																	color={getStatusColor(
																		followUp.status
																	)}
																	size="small"
																/>
															</TableCell>
															<TableCell
																sx={{ whiteSpace: 'pre-line' }}
															>
																{followUp.notes}
															</TableCell>
														</TableRow>
													)
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</Box>
							)}
						</Box>
					)}
				</DialogContent>

				<DialogActions sx={{ padding: 2 }}>
					<Button
						onClick={handleCloseDialogs}
						variant="outlined"
						sx={{
							px: 3,
							'&:hover': {
								backgroundColor: 'grey.100',
							},
						}}
						fullWidth={isMobile}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>

			{/* Edit Inquiry Dialog */}
			<Dialog
				open={openEditDialog}
				onClose={handleCloseDialogs}
				maxWidth="md"
				fullWidth
				fullScreen={isMobile}
			>
				<DialogTitle>
					<Box display="flex" justifyContent="space-between" alignItems="center">
						Update Inquiry
						<IconButton onClick={handleCloseDialogs}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent dividers>
					{selectedInquiry && (
						<Box>
							<Box
								display="flex"
								mb={3}
								flexDirection={isMobile ? 'column' : 'row'}
								flexWrap="wrap"
							>
								<Box
									width={isMobile ? '100%' : '50%'}
									minWidth={isMobile ? undefined : 300}
									pr={isMobile ? 0 : 2}
								>
									<Typography variant="h6" gutterBottom>
										Inquiry Details
									</Typography>
									<TextField
										label="Name"
										value={selectedInquiry.name}
										fullWidth
										margin="normal"
										variant="outlined"
										InputProps={{
											readOnly: true,
										}}
									/>
									<TextField
										label="Email"
										value={selectedInquiry.email}
										fullWidth
										margin="normal"
										variant="outlined"
										InputProps={{
											readOnly: true,
										}}
									/>
									<TextField
										label="Phone Number"
										value={selectedInquiry.mobile}
										fullWidth
										margin="normal"
										variant="outlined"
										InputProps={{
											readOnly: true,
										}}
									/>
								</Box>
								<Box
									width={isMobile ? '100%' : '20%'}
									minWidth={isMobile ? undefined : 100}
									pl={isMobile ? 0 : 2}
								>
									<Typography variant="h6" gutterBottom>
										Status
									</Typography>
									<FormControl fullWidth margin="normal">
										<InputLabel>Follow Up Status</InputLabel>
										<Select
											value={selectedInquiry.followupStatus}
											label="Follow Up Status"
											onChange={(e) =>
												handleStatusChange(
													selectedInquiry._id,
													e.target.value as string
												)
											}
										>
											{statusOptions.map((status) => (
												<MenuItem key={status} value={status}>
													<Chip
														label={status}
														size="small"
														color={getStatusColor(status)}
														sx={{ width: '100%' }}
													/>
												</MenuItem>
											))}
										</Select>
									</FormControl>
									<TextField
										label="Created At"
										value={formatDate(selectedInquiry.createdAt)}
										fullWidth
										margin="normal"
										variant="outlined"
										InputProps={{
											readOnly: true,
										}}
									/>
								</Box>
							</Box>

							<Box mt={2}>
								<Typography variant="subtitle1" gutterBottom>
									<strong>Original Message:</strong>
								</Typography>
								<Typography
									paragraph
									sx={{ p: 1, backgroundColor: '#f5f5f5', borderRadius: 1 }}
								>
									{selectedInquiry.message}
								</Typography>
							</Box>

							<Box mt={3}>
								<Typography variant="h6" gutterBottom>
									Add Follow Up Notes
								</Typography>
								<TextField
									label="Notes"
									value={followUpNotes}
									onChange={(e) => setFollowUpNotes(e.target.value)}
									fullWidth
									margin="normal"
									variant="outlined"
									multiline
									rows={4}
								/>
							</Box>

							{selectedInquiry.followUps && selectedInquiry.followUps.length > 0 && (
								<Box mt={3}>
									<Typography variant="h6" gutterBottom>
										Previous Follow Ups
									</Typography>
									<TableContainer component={Paper} variant="outlined">
										<Table size="small">
											<TableHead>
												<TableRow>
													<TableCell>Date</TableCell>
													<TableCell>Status</TableCell>
													<TableCell>Notes</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{selectedInquiry.followUps.map(
													(followUp, index) => (
														<TableRow key={index}>
															<TableCell>{followUp.date}</TableCell>
															<TableCell>
																<Chip
																	label={followUp.status}
																	color={getStatusColor(
																		followUp.status
																	)}
																	size="small"
																/>
															</TableCell>
															<TableCell>{followUp.notes}</TableCell>
														</TableRow>
													)
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</Box>
							)}
						</Box>
					)}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleCloseDialogs}
						sx={{
							'&:hover': {
								backgroundColor: 'primary.main',
								color: 'white',
							},
						}}
						fullWidth={isMobile}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="primary"
						onClick={handleAddFollowUp}
						fullWidth={isMobile}
						sx={{ mt: isMobile ? 1 : 0 }}
					>
						Save Changes
					</Button>
				</DialogActions>
			</Dialog>

			{/* Contact Form Dialog */}
			<Dialog
				open={openContactForm}
				onClose={handleCloseContactForm}
				maxWidth="sm"
				fullWidth
				fullScreen={isMobile}
			>
				<DialogTitle>
					<Box display="flex" justifyContent="space-between" alignItems="center">
						Add New Inquiry
						<IconButton onClick={handleCloseContactForm}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent dividers>
					<DialogContentText gutterBottom>
						Please fill out the form below to submit a new inquiry.
					</DialogContentText>

					<Box
						component="form"
						onSubmit={handleContactFormSubmit}
						noValidate
						sx={{ mt: 2 }}
					>
						<TextField
							label="Name"
							name="name"
							size="small"
							color="primary"
							value={contactFormData.name}
							onChange={handleContactFormChange}
							error={!!contactFormErrors.name}
							helperText={contactFormErrors.name}
							fullWidth
							margin="normal"
							required
						/>

						<TextField
							label="Email"
							name="email"
							color="primary"
							size="small"
							value={contactFormData.email}
							onChange={handleContactFormChange}
							error={!!contactFormErrors.email}
							helperText={contactFormErrors.email}
							fullWidth
							margin="normal"
							required
						/>

						<TextField
							label="Whatsapp Number"
							name="contactNo"
							type="tel"
							size="small"
							color="primary"
							value={contactFormData.contactNo}
							onChange={handleContactFormChange}
							error={!!contactFormErrors.contactNo}
							helperText={contactFormErrors.contactNo}
							fullWidth
							margin="normal"
							required
						/>
						<TextField
							label="Location"
							name="location"
							type="text"
							size="small"
							color="primary"
							fullWidth
							sx={{ mt: 2 }}
							value={contactFormData.location}
							onChange={handleContactFormChange}
							error={!!contactFormErrors.location}
							helperText={contactFormErrors.location}
						/>
						<TextField
							label="Description"
							name="description"
							color="primary"
							size="small"
							value={contactFormData.description}
							onChange={handleContactFormChange}
							error={!!contactFormErrors.description}
							helperText={contactFormErrors.description}
							fullWidth
							margin="normal"
							multiline
							rows={4}
							required
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleCloseContactForm}
						sx={{
							'&:hover': {
								backgroundColor: 'grey.100',
							},
						}}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="primary"
						onClick={handleContactFormSubmit}
						disabled={isSubmitting}
					>
						{isSubmitting ? 'Submitting...' : 'Submit'}
					</Button>
				</DialogActions>
			</Dialog>

			<Toast
				setAlertMessage={setAlertMessage}
				alertMessage={alertMessage}
				alertSeverity={alertSeverity}
			/>
		</Container>
	);
};

export default InquiriesPage;
